import { refreshServerConfig } from 'lib/auth';

import type { RequestUser } from 'shared-types';
import type { AppDispatch } from 'types';

interface Params {
  dispatch: AppDispatch;
  user: Partial<RequestUser>;
}

/**
 * Apply a newly authenticated user to Redux and refresh serverConfig.
 * Needed after login.
 */
const applyAuthenticatedSession = async ({ dispatch, user }: Params) => {
  dispatch.setUser(user);
  await refreshServerConfig(dispatch);
};

export default applyAuthenticatedSession;
